module.exports = __webpack_public_path__ + "img/sidebar_document.5bc0bbfb.svg";